import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import objectPath from "object-path";
/* import KTToggle from "../assets/js/toggle"; */
import { toAbsoluteUrl } from "../../utils/utils";
import * as builder from "../../reducers/builder";
import Config from '../../configs/Config';
import {getMerchantLogo} from '../../utils/MerchantUtils';


class HeaderMobile extends React.Component {
  toggleButtonRef = React.createRef();
  headerMobileCssClasses = "";
  layoutConfig = this.props.layoutConfig;
 /*  componentDidMount() {
    new KTToggle(this.toggleButtonRef.current, this.props.toggleOptions);
  } */

  render() {
    const {
      asideDisplay,
      headerMobileCssClasses,
      headerMobileAttributes,
      merchant
    } = this.props;

    const logoPath = merchant ? getMerchantLogo(merchant.images) : '';
    return (
      <div
        id="kt_header_mobile"
        className={`kt-header-mobile ${headerMobileCssClasses}`}
        {...headerMobileAttributes}
      >
        <div className="kt-header-mobile__logo">
          <Link to="/">
            <img alt="logo" 
             height="35" width="47"src={
             logoPath ? Config.staticDomain + logoPath : toAbsoluteUrl("/media/logos/logo-4-sm.png")} />
          </Link>
        </div>

        <div className="kt-header-mobile__toolbar">
          {asideDisplay && (
            <button
              className="kt-header-mobile__toolbar-toggler kt-header-mobile__toolbar-toggler--left"
              id="kt_aside_mobile_toggler"
            >
              <span />
            </button>
          )}

          <button
            className="kt-header-mobile__toolbar-toggler"
            id="kt_header_mobile_toggler"
          >
            <span />
          </button>

          <button
            ref={this.toggleButtonRef}
            className="kt-header-mobile__toolbar-topbar-toggler"
            id="kt_header_mobile_topbar_toggler"
          >
            <i className="flaticon-more-1" />
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  headerMobileCssClasses: builder.selectors.getClasses(store, {
    path: "header_mobile",
    toString: true
  }),
  headerMobileAttributes: builder.selectors.getAttributes(store, {
    path: "header_mobile"
  }),
  asideDisplay: objectPath.get(
    store.builder.layoutConfig,
    "aside.self.display"
  ),
  toggleOptions: {
    target: "body",
    targetState: "kt-header__topbar--mobile-on",
    togglerState: "kt-header-mobile__toolbar-topbar-toggler--active"
  },
  merchant: store.Merchant.merchant,
});

export default connect(mapStateToProps)(HeaderMobile);
